import {
  takeEvery, call, put, all, delay,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import firebase from '../../firebase';
import 'firebase/firestore';

import * as types from '../types';

function* createPet(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets');

    const petData = {
      type: action.payload.values.type || '',
      name: action.payload.values.name || '',
      gender: action.payload.values.gender || '',
      breed: action.payload.values.type.label === 'Other' ? { value: 0, label: action.payload.values.breed } : action.payload.values.breed || '',
      color: action.payload.values.color || '',
      dob: action.payload.values.dob || '',
      owner: action.payload.values.owner || '',
      ownerName: action.payload.values.ownerName || '',
    };

    const response = yield call(
      [tempQuery, tempQuery.add],
      petData,
    );

    const updateClientQuery = db.collection('clients').doc(action.payload.values.owner);
    const check = {
      owned: firebase.firestore.FieldValue.arrayUnion(
        {
          value: response.id,
          label: action.payload.values.name,
        },
      ),
    };

    yield call(
      [updateClientQuery, updateClientQuery.update],
      check,
    );

    yield put({
      type: types.CREATE_PET_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Created pet');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.CREATE_PET_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}


function* editPet(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').doc(action.payload.id);

    yield call(
      [tempQuery, tempQuery.update],
      action.payload.values,
    );

    yield put({
      type: types.EDIT_PET_DATA_SUCCESS,
    });

    yield delay(500);
    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Created pet');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.EDIT_PET_DATA_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* getAllPets(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').orderBy('name', 'asc');

    const querySnapshot = yield call(
      [tempQuery, tempQuery.get],
    );

    const petList = [];

    yield all(querySnapshot.docs.map(doc => petList.push({
      value: doc.id,
      label: doc.data().name,
      type: doc.data().type,
      breed: doc.data().breed,
      gender: doc.data().gender,
      color: doc.data().color,
      lastTreatment: doc.data().lastTreatment,
      lastVaccination: doc.data().lastVaccination,
      owner: doc.data().owner,
      ownerName: doc.data().ownerName,
    })));

    yield put({
      type: types.GET_ALL_PETS_SUCCESS,
      payload: {
        petList,
      },
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.GET_ALL_PETS_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* getSinglePetData(action) {
  try {
    const db = firebase.firestore();
    const getSinglePetQuery = db.collection('pets').doc(action.payload.id);

    const response = yield call(
      [getSinglePetQuery, getSinglePetQuery.get],
    );

    yield put({
      type: types.GET_PET_DATA_SUCCESS,
      payload: {
        petData: response.data(),
      },
    });
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.GET_PET_DATA_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* deletePet(action) {
  try {
    const db = firebase.firestore();
    const getSinglePetQuery = db.collection('pets').doc(action.payload.id);

    // delete treatment reports here for the pet first, then delete pet
    yield call(
      [getSinglePetQuery, getSinglePetQuery.delete],
    );

    yield put({
      type: types.DELETE_PET_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Deleted pet successfully');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.DELETE_PET_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}
export default function* () {
  yield takeEvery(types.CREATE_PET_REQUEST, createPet);
  yield takeEvery(types.EDIT_PET_DATA_REQUEST, editPet);
  yield takeEvery(types.GET_ALL_PETS_REQUEST, getAllPets);
  yield takeEvery(types.GET_PET_DATA_REQUEST, getSinglePetData);
  yield takeEvery(types.DELETE_PET_REQUEST, deletePet);
}
